import { chatSdk, chatEventEmitter } from '@wix/chat-sdk';
import { INIT_CHAT_SDK } from '../actions';
import { ViewerOnMessageReceivedEvent } from '../constants/viewer-event-types';
import wix from '../services/wix';

const chatSdkMiddleware = store => next => action => {
  switch (action.type) {
    case INIT_CHAT_SDK: {
      const experiments = store.getState().experimentsRaw;
      chatSdk.init({
        chatServerUrl: '/',
        chatToken: action.coreChatToken,
        ...(action.isBusinessChat ? { preFetch: false } : {}),
        experiments,
      });

      chatEventEmitter.addListener(
        chatEventEmitter.CHAT_EVENTS.NEW_REALTIME_MESSAGE,
        message => wix.publishToPubSub(ViewerOnMessageReceivedEvent, message),
      );

      return next(action);
    }
    default:
      return next(action);
  }
};

export default chatSdkMiddleware;
